import { Component, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoundIconComponent } from '../../shared/round-icon/round-icon.component';
import { IconNameType } from '../../shared/icons/icon-name-type.enum';
import { IconComponent } from '../../shared/icons/icon.component';
import { GenericModalContext, ModalName, ModalService } from '../services/modal.service';

@Component({
  selector: 'cwo-generic-modals',
  standalone: true,
  imports: [RoundIconComponent, IconComponent, CommonModule],
  templateUrl: './generic-modals.component.html',
  styleUrl: './generic-modals.component.scss'
})
export class GenericModalsComponent {
  modalService = inject(ModalService);

  iconNameType = IconNameType;

  get modalContext() {
    return this.modalService.stateForModal(ModalName.Generic) as GenericModalContext | undefined;
  }

  @HostListener('document:keydown.escape', ['$event'])
  handleEscapeKey() {
    this.modalService.closeModal(ModalName.Generic);
  }


  closeModal() {
    this.modalService.closeModal(ModalName.Generic);
  }

  get ariaLabelForClose() {
    return `Close ${this.modalContext?.isAlert ? 'Alert' : this.modalContext?.modalTitle } Modal`;
  }

  secondaryAction() {
    let result;
    if (this.modalContext?.secondaryAction) {
      result = this.modalContext.secondaryAction();      
    }
    if (this.modalContext?.closeOnAction) {
      this.modalService.closeModal(ModalName.Generic, result);
    }
  }

  confirmAction() {
    let result;
    if (this.modalContext?.primaryAction) {
      result = this.modalContext.primaryAction();      
    }
    if (this.modalContext?.closeOnAction) {
      this.modalService.closeModal(ModalName.Generic, result);
    }
  }

}
